import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthenticationService} from '../services/apiServices/security/authentication.service';
import {HttpService} from '../services/apiServices/http-service.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {MessageService, SelectItem} from 'primeng/api';
import {StorageService} from '../services/storage/storage.service';
import {instances} from '../properties';
import {environment} from '../../environments/environment';
import {CommonService} from '../services/apiServices/business/common.service';
import {PasswordService} from '../services/apiServices/security/password.service';
import {CreateDepositService} from '../services/apiServices/business/create-deposit.service';
import {ModService} from '../services/apiServices/business/mod.service';

/**
 * Handle the whole shell of the application (displayLoading content if a user is logged or not) and the loading screen
 */
@Component({
  selector: 'app-my-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApplicationComponent implements OnInit {

  /**
   * if the user is logged
   */
  public isLogged: boolean;
  public requirePasswordChange: boolean;

  /**
   * if the component should display the blocking loading screen
   */
  public displayLoading: boolean;
  public messageOfTheDay: any;
  public locales: SelectItem [];
  public locale: string;
  public navBarClass: string;
  public navBarlogo: string;
  public isNewPasswordValid: boolean;
  public isNewPasswordConfirmValid: boolean;
  public changePasswordFail: boolean;
  public actualPassword: string;
  public newPassword: string;
  public verifyPassword: string;
  public successTitle: string;
  public successMessage: string;
  public errorMessage: string;
  public passwordInvalidMsg: string;
  public passwordConfirmInvalidMsg: string;
  runningExpressDeposit: string;
  /**
   *
   * default constructor that instantiate services (if not done before)
   *
   * @param storageService
   * @param {AuthenticationService} authenticationService - required to check if the user is logged
   * @param {HttpService} httpService - required to know when the component should display the loading screen
   * @param translate required for i18 translation
   * @param passwordService
   * @param commonService
   * @param createDepositService
   */
  constructor(private storageService: StorageService, private authenticationService: AuthenticationService,
              private httpService: HttpService, private translate: TranslateService,
              private passwordService: PasswordService, private commonService: CommonService,
              private modService: ModService,
              public createDepositService: CreateDepositService) {

  }

  /**
   * function that handleChangeOfSelectFold the start of subscriptions for isLogged and displayLoading
   */
  public ngOnInit(): void {
    this.runningExpressDeposit = '';
    this.createDepositService.runningExpressDeposit.subscribe( deposit => {
      this.runningExpressDeposit = deposit;
    });
    this.requirePasswordChange = false;
    this.navBarClass = environment.instance + '-nav-bar';
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (this.messageOfTheDay) {
        if (event.lang === 'en') {
          this.translate.set('MOTD_CONTENT', this.messageOfTheDay.MOTD_CONTENT_FR, 'en');
        } else {
          this.translate.set('MOTD_CONTENT', this.messageOfTheDay.MOTD_CONTENT_EN, 'en');
        }
      }
      this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
        this.successTitle = title;
      });
      this.translate.get('TOASTER.MODIFY_PASSWORD_ASK_OK').subscribe((message: string) => {
        this.successMessage = message;
      });
      this.translate.get('CREATE.PASSWORD_COMPONENT.INPUT_PROMPT_LABEL').subscribe(message => {
        this.passwordInvalidMsg = message;
      });
      this.translate.get('CREATE.PASSWORD_COMPONENT.COFIRM_IDENTICAL').subscribe(message => {
        this.passwordConfirmInvalidMsg = message;
      });
    });
    this.navBarlogo = instances.numen.login.logo;
    if (instances[environment.instance] && instances[environment.instance].login && instances[environment.instance].login.logo) {
      this.navBarlogo = instances[environment.instance].login.logo;
    }
    this.displayLoading = false;
    if (this.storageService.getLangFromStorage()) {

      this.locale = this.storageService.getLangFromStorage();
    } else {
      this.locale = this.translate.currentLang;
    }
    this.passwordService.errorMessage.subscribe(
      error => {
        this.errorMessage = error;
      }
    );
    this.authenticationService.changeLang(this.locale)
    this.locales = [
      {label: 'Français', value: 'fr'},
      {label: 'English', value: 'en'}
    ];
    this.authenticationService.isLogged.subscribe(logResult => {
      this.isLogged = logResult;
    });
    this.authenticationService.requirePasswordChange.subscribe( required => {
      this.requirePasswordChange = required;
    });
    setTimeout(() => {
      this.httpService.pendingToProcess.subscribe(result => {
        this.setDisplayLoading(result > 0);
      });
    }, 3000);
    if(this.authenticationService.getCurrentUser() && ((this.authenticationService.getCurrentUser().isAuthorizedExpress) || this.authenticationService.getCurrentUser().admin)){
      setTimeout(() => {
        this.getExpressDepositInProgress();
      }, 2000);
    }
  }

  public setDisplayLoading(pending: boolean): void {
    setTimeout(() => {
      this.displayLoading = pending;
    });
  }

  public updateLocale(): void {
    this.storageService.addLangInStorage(this.locale);
    this.authenticationService.changeLang(this.locale);
  }
  public getUserMessageOfTheDay(): string {
    return this.modService.getUserMessageOfTheDay();
  }
  public formIsComplete(): boolean {
    return this.actualPassword && this.isNewPasswordValid && this.isNewPasswordConfirmValid;
  }

  /**
   * handleChangeOfSelectFold the change of password, it'll display a message if it's a false, else it'll log-out the user
   */
  public changePassword(): void {
    this.passwordService.changePassword(this.actualPassword, this.newPassword, this.verifyPassword).subscribe(result => {
      this.changePasswordFail = !result;
      if (result) {
        this.commonService.addToast({life: 3000, severity: 'success', summary: this.successTitle, detail: this.successMessage});
        this.authenticationService.logout();
      }
    });
  }
  public getExpressDepositInProgress() {
    this.createDepositService.getExpressDepositInProgress().subscribe(response => {
      if (response.hasOwnProperty('dirs')) {
        const dirs = response.dirs;
        if (dirs && dirs.length > 0) {
          this.createDepositService.runningExpressDeposit.emit(dirs[0]);
        }
      }
    });
  }
}
